<template>
  <div class="wrapper" ref="treeWrap">
    <div class="widget">
      <div class="whead">
        <div class="whead-left">
          <Icon :type="icon" :size="20" v-if="icon"></Icon>
          <span class="whead-left-title">{{title}}</span>
        </div>
      </div>
      <div class="wneck">
        <div class="tree-search">
          <Input type="text" v-model="treeSearchword"
                 @on-change="treeSearch" clearable placeholder="搜索" style="width: 150px" >
            <Icon type="ios-search" slot="prepend"></Icon>
          </Input>
          <Button size="small" type="text"
                  @click="changeTreeNodeExpand(showExpandBtn)"
                  v-if="showExpandBtn" >
            展开
            <Icon type="md-arrow-round-down" />
          </Button>
          <Button size="small" type="text"
                  @click="changeTreeNodeExpand(showExpandBtn)"
                  v-if="!showExpandBtn" >
            收起
            <Icon type="md-arrow-round-up" />
          </Button>
        </div>
      </div>
      <div class="content" :style="contentStyle" v-height="{offsetHeight:offsetHeight}">
        <div class="no-data-span" v-if="noDataText && treeData.length === 0 ">
          <Icon type="iconfont iconwushuju" size="88"/>
          <h6  v-html="noDataTips"></h6>
        </div>
        <v-tree ref='paasTree'
                :data='treeData' @node-click="clickTreeNode" @node-right-click="rightClickMenu"/>
      </div>
    </div>
    <div v-show="treeMenuShow" :style="treeMenuPosition" ref="paasTreeMenu" class="paas-tree-menu" v-clickoutside="hideTreeMenu">
      <ul>
        <li @click="paasAddChildNode" ><Icon type="md-add" size="16"></Icon> 增加子节点</li>
        <li @click="treeEditNode"><Icon type="md-brush" size="16"></Icon> 修改当前节点</li>
        <li @click="treeDeleteNode"><Icon type="ios-trash-outline" size="16"></Icon> 删除当前节点</li>
        <li @click="paasTreeOrder"><Icon type="md-reorder" size="16"></Icon> 子节点排序</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { getTreeData , getCurrentNodeParentId , deleted , getSiblingIds , getTreeParentIds} from "@api/admin.js";
  export default {
    name: "wrapper-tree",
    props: {
      title: {
        type: String,  //panel 标题
      },
      icon: {
        type: String,  //功能icon，只支持icon
      },
      wbodyPadding:{
        type: String,  //body的间隙
        default: '10px'
      },
      offsetHeight:{
        type:[Number,String], //相对高度
      },
      offsetWidth:{
        type:[Number,String], //相对width
      },
      noDataTips: {
        type: String,  //数据为空时显示的提示内容
        default:'暂时没有数据'
      },
      serviceUrl:{
        type: String,  //后台controller路径
      },
      currentIdFiledName:{
        type: String,  //主键id的属性名
      },
      treeType:{
        type:String,  //树的查询还是编辑(query/edit)
        default:"edit",
      },
      startTreeCode:{
        type:String, //起始树节点,只传paasLikeTreeCode的值 '100'、'101'等等
      },
      treeNodeIcon:{
        type:String //树节点的icon图标
      }
    },
    data(){
      return{
        treeSearchword:'', //树查询的输入框
        showExpandBtn:true, //默认初始化树是展开的
        isRoot:false, //是否显示添加根节点
        treeData:[], //树数据
        noDataText:false,//treeData为空的时候显示图片
        queryParam:{
          query_LIKE_nodeCode:'',
        },//table必须的
        paasTreeSelectedNodeId:'',
        parentId:'',
        currentNode:{},
        treeMenuShow:false,
        treeMenuPosition: {position: 'absolute', top: '20000000px', left: '30000000px', zIndex: '999999'},
      }
    },
    computed:{
      contentStyle:function (){
        let style = {};
        style.padding = this.wbodyPadding;
        style.paddingLeft = (parseInt(this.wbodyPadding) + 10) + "px";
        return style;
      }
    },
    created(){
      this.queryTreeDatas();
    },
    mounted(){
      this.watchUpdateTree();
    },
    methods:{
      /**
       * 是否显示“添加根节点”的操作：只能在编辑类型且父节点为root的根节点才会出现
       * 一般路由配置,查询某个节点需要传参
       */
      isShowRootOper(){
        if(this.treeType === "edit" && !this.startTreeCode){
          this.isRoot = true;
        }else{
          this.isRoot = false;
        }
      },
      /**
       * 获取树的数据
       */
      queryTreeDatas() {
        //暂时不支持code查询
        let nodeCode = this.$route.query.nodeCode;
        if(nodeCode){
          this.queryParam['query_LIKE_nodeCode'] = nodeCode;
          this.nodeCode = nodeCode;
        }
        /**
         * 1、判断是否显示“添加根节点”
         */
        this.isShowRootOper();
        getTreeData(this.serviceUrl,this.queryParam).then(res => {
          if(res.code === 200) {
            /**
             * 1、获取树的数据
             */
            this.treeData = res.data;
            //console.log(JSON.stringify(this.treeData));
            if(this.treeData.length === 0){
              this.noDataText = true;
            }
            /**
             * 2、如若treeData数组只有一个，展开一级节点；若treeData数组多个，则不展开
             */
            if(this.treeData.length === 1){
              this.treeData[0].expanded = true;
            }
          }
        }).catch(error => {
          this.$Message.info("数据刷新失败"+error);
        });
      },

      /**
       * 右键
       * */
      rightClickMenu(node, clientX, clientY) {
        if(this.treeType !== "query"){
          this.showTreeMenu(clientX, clientY);
          this.paasTreeSelectedNodeId = node.id;
          this.currentNode = node;
          this.$refs.paasTree.setTreeNodeAttr(node.id, 'selected', true);
          getCurrentNodeParentId(this.serviceUrl,node.id).then(
            res=>{
              if(res.code === 200){
                this.parentId = res.data
              }
            }
          ).catch(error=>{
            console.log(error)
          })
        }
      },

      /**
       *  设置菜单位置并显示
       */
      showTreeMenu(clientX, clientY) {
        let menuHeight = parseInt(this.$refs.paasTreeMenu.offsetHeight);
        if(document.documentElement.clientHeight - menuHeight < clientY) {
          clientY = clientY - menuHeight;
        }
        let clientRect = this.$refs.treeWrap.getBoundingClientRect();
        this.treeMenuPosition.top = (clientY-clientRect.top)+"px";
        this.treeMenuPosition.left = (clientX-clientRect.left)+"px";
        this.treeMenuShow = true;
      },
      /**
       *  添加子节点
       */
      paasAddChildNode(event,url){
        if(!url) {
          url = this.serviceUrl+"/edit?parentId="+this.paasTreeSelectedNodeId;
        }
        this.$router.push({'path':this.setUrlFuncId(url)});
        this.treeMenuShow = false;
        this.$emit('getKeyChange')
      },

      /**
       *  编辑节点
       */
      treeEditNode(event,url){
        if(!url) {
          url = this.serviceUrl+"/edit?"+this.currentIdFiledName+'='+this.paasTreeSelectedNodeId+"&parentId="+ this.parentId;
        }
        this.$router.push({'path':this.setUrlFuncId(url)});
        this.treeMenuShow = false;
        this.$emit('getKeyChange')
      },
      /**
       *  删除节点
       */
      treeDeleteNode(){
        this.treeMenuShow = false;
        this.$Modal.confirm({
          title: '系统提示',
          content: '删除操作将会把本节点及其所有下级节点以及所有附件全部删除，确定要删除吗？',
          onOk: () => {
            this.paasDeleteNode(this.paasTreeSelectedNodeId);
          },
          onCancel: () => {
            this.$Modal.remove()
          }
        })
      },
      paasDeleteNode(nodeId){
        deleted(this.serviceUrl,this.currentIdFiledName,nodeId).then(res=>{
          this.$Modal.remove();
          this.$Message.info('数据删除成功！');
          this.$bus.emit("update-list",nodeId);
        }).catch(error=>{
          this.$Modal.remove();
          this.$Message.info('数据删除失败，请重试！');
        });
      },
      /**
       *   隐藏菜单
       */
      hideTreeMenu() {
        this.treeMenuShow = false;
      },
      /**
       * 子节点排序
       */
      paasTreeOrder(){
        this.clickTreeNode(this.currentNode);
        this.treeMenuShow = false;
        this.$Modal.info(
          {
            title:'提示',
            content: '<p>进入子节点列表页面，拖动列表项可对子节点进行顺序调整！</p>',
          }
        );
      },
      /**
       * 树的查询,传递输入查询的值
       */
      treeSearch(){
        this.$refs.paasTree.searchNodes(this.treeSearchword);
      },
      /**
       * 展开还是收起
       */
      changeTreeNodeExpand(status){
        this.showExpandBtn = !status;
        this.treeData = this.switchForTreeNodes(this.treeData,status);
        /**
         * 如若树只有一个根节点，展开这个根节点
         */
        if(this.treeData.length === 1){
          this.treeData[0].expanded = true;
        }
      },
      /**
       * 更改树展开状态
       */
      switchForTreeNodes(node,status){
        for(let i = 0; i < node.length; i++){
          let nodeChildren = node[i].children;
          node[i].expanded = status;
          if(nodeChildren.length === 0){
            continue;
          }
          this.switchForTreeNodes(nodeChildren,status);
        }
        return node;
      },
      /**
       * 点击树节点
       * @param node
       */
      clickTreeNode(node){
        //收起所有同级节点
        this.expandedSiblingTreeIds(node,false);
        this.$emit("on-node-click",node);
        this.$refs.paasTree.setTreeNodeAttr(node.id, 'selected', true);
      },
      /**
       * 更改某节点所有同级节点expanded状态
       * @param node
       * @param flag
       * */
      expandedSiblingTreeIds(node,flag){
        getSiblingIds(this.serviceUrl,node.id).then(
          res=>{
            if(res.code === 200){
              let ids = res.data;
              for(let i=0;i<ids.length;i++){
                if(ids[i] === node.id){
                  this.$refs.paasTree.setTreeNodeAttrById(this.treeData,ids[i],"expanded",!flag);
                }else{
                  this.$refs.paasTree.setTreeNodeAttrById(this.treeData,ids[i],"expanded",flag);
                }
              }
            }
          }
        )
      },
      /**
       * 更改某节点所有父节点expanded状态
       * @param node
       * @param flag
       */
      expandedParentTreeIds(node,flag){
        getTreeParentIds(this.serviceUrl,node.id).then(
          res=>{
            if(res.code === 200){
              let ids = res.data.split(',')
              for(let i=0;i<ids.length;i++){
                this.$refs.paasTree.setTreeNodeAttrById(this.treeData,ids[i],"expanded",flag);
              }
            }
          }
        )
      },
      watchUpdateTree(){
        /**
         * 添加或者修改保存时检测到调用的方法
         */
        let that = this;
        if(this.treeType !== "query"){
          /**
           * 监测添加或者修改树节点的bus
           */

          this.$bus.on("update-tree",function(flag,res){
            this.noDataText = false;
            if(flag === "edit"){
              let currentNodeId = res.data.entity.id;
              let currentParentId = res.data.entity.parentId;
              let parentNode = "";
              let hasChangeParent = "yes";
              //判断是否修改根节点
              //修改的不是根节点
              if(currentParentId && typeof(currentParentId) !== "undefined"){
                parentNode = that.$refs.paasTree.getNodes({id:currentParentId},that.treeData,true);
                if(parentNode != null && parentNode.length > 0){
                  let children = parentNode[0].children;
                  for(let i = 0; i< children.length; i++){
                    if(currentNodeId === children[i].id){
                      hasChangeParent = "no";
                      break;
                    }
                  }
                }
              }
              //修改的是根节点
              else{
                for(let i = 0; i< that.treeData.length; i++){
                  if(currentNodeId === that.treeData[i].id){
                    hasChangeParent = "no";
                    break;
                  }
                }
              }

              if(hasChangeParent === "yes"){
                let currentNode = that.$refs.paasTree.getNodes({id:res.data.entity.id},that.treeData,true);
                that.$refs.paasTree.deleteNodes(currentNodeId);
                that.$refs.paasTree.addNodeByParentId(currentParentId, currentNode[0]);
              }else{
                that.$refs.paasTree.setTreeNodeAttr(res.data.entity.id, 'title', res.data.entity.title);
              }

            }else{
              that.$refs.paasTree.addNodeByParentId(res.data.entity.parentId, res.data.entity);
            }
          });
          /**
           * 监测列表页面删除树节点的bus
           */
          this.$bus.on("update-delete-tree",function(nodeId){
            that.$refs.paasTree.deleteNodes(nodeId);
          });
          /**
           * 监测树节点排序的bus
           */
          this.$bus.on("update-order-tree",function(parentId,fromIndex,toIndex){
            if(parentId !== "root"){
              //返回的是一个数组
              let parentNode = that.$refs.paasTree.getNodes({id:parentId},this.treeData,true);
              if(parentNode != null && parentNode.length > 0){
                let children = parentNode[0].children;
                //filter 过滤掉第index1的数据
                let newChildren = children.filter(data => {
                  return data.id !== children[fromIndex].id;
                })
                //把index1数据放到index2位置
                newChildren.splice(toIndex,0,children[fromIndex]);
                that.$set(parentNode[0], 'children', newChildren);
              }
            }else{
              let rootNodes = that.treeData;
              //filter 过滤掉第index1的数据
              let newChildren = rootNodes.filter(data => {
                return data.id !== rootNodes[fromIndex].id;
              })
              //把index1数据放到index2位置
              newChildren.splice(toIndex,0,rootNodes[fromIndex]);
              that.treeData = newChildren;
            }

          })
        }else{
          this.$bus.on("update-tree",function(flag,res){
            this.noDataText = false;
            if(flag === "add"){
              that.$refs.paasTree.addNodeByParentId(res.data.entity.parentId, res.data.entity);
            }
          })
        }
      },

      /**
       * url添加功能ID参数,封装这个方法是以防功能配置也有传参数
       * */
      setUrlFuncId(url) {
        if(url.indexOf("?") !== -1) {
          url += '&';
        } else {
          url += '?';
        }
        //组装paasCurrentFunctionId=***
        url += this.$store.state.funcIdName+'='+this.$route.query[this.$store.state.funcIdName];
        return url;
      },
    },

  }
</script>

<style scoped>
  @import '../../assets/css/wrapper-tree.css';
</style>
